import SubscriptionPayment from "./SubscriptionPayment";

export default SubscriptionPayment;
